import { useNavigate } from 'react-router-dom';
import './Heading.scss';
import { IoIosArrowForward } from 'react-icons/io';
import { useSelector } from 'react-redux';
import { Tag } from 'antd';
import StatusTag from '../../../hooks/StatusHook';

const Heading = ({ title, subTitle, path, status }) => {
  const { currentLang } = useSelector((state) => state.user);
  const navigate = useNavigate();
  return (
    <div className="heading">
      <h4
        className="heading-title"
        style={{
          cursor: 'pointer',
        }}
        onClick={() => navigate(path)}
      >
        {title}
      </h4>
      <div className="heading-sub">
        {status ? (
          <StatusTag status={status} />
        ) : (
          <>
            <p className="heading-subtitle">{title}</p>
            <div
              style={{
                display: 'flex',
                transform:
                  currentLang === 'en' ? 'rotate(0deg)' : 'rotate(180deg)',
              }}
            >
              <IoIosArrowForward />
            </div>
            <p className="heading-subtitle">{subTitle}</p>
          </>
        )}
      </div>
    </div>
  );
};

export default Heading;
